import { z } from "zod";
import { mediaSchema } from "../zod/mediaSchema.js";
import { nonEmptyString } from "../zod/nonEmptyString.js";

export const quoationBlockSchema = z.object({
	image: mediaSchema,
	quotation: nonEmptyString,
	authorName: nonEmptyString,
	authorTitle: nonEmptyString,
});
